var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10 md:mt-32"},[_c('div',{staticClass:"flex items-center justify-center bg-baseWhite app-footer py-10"},[_c('Social')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }